const lightTheme = {
    background: '#2c2c2c',
    fontColor: '#fff',
    activeBackground: '#fff',
    activeFontColor: '#000',
    backgroundBody: 'rgb(131,131,131)',
    bodyBackground: 'linear-gradient(87deg, rgba(131,131,131,1) 0%, rgba(193,193,193,1) 38%, rgba(251,251,251,1) 100%)',
    theme: 'light',
    gradient: 'radial-gradient(circle farthest-corner at 10% 20%, rgba(253, 203, 50, 1) 0%, rgba(244, 56, 98, 1) 100.2%)',
};

const darkTheme = {
    background: '#fff',
    fontColor: '#000',
    activeBackground: '#000',
    activeFontColor: '#fff',
    backgroundBody: 'rgb(0,0,0)',
    bodyBackground: 'linear-gradient(87deg, rgba(0,0,0,1) 0%, rgba(70,70,70,1) 48%, rgba(116,116,116,1) 100%)',
    theme: 'dark',
    gradient: 'linear-gradient(109.8deg,rgba(62, 5, 116, 1) -5.2%,rgba(41, 14, 151, 1) -5.2%,rgba(216, 68, 148, 1) 103.3%)',
};

export { lightTheme, darkTheme };
